import script from "./FeedbackDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeedbackDetail.vue?vue&type=script&setup=true&lang=ts"

import "./FeedbackDetail.vue?vue&type=style&index=0&id=5be6ce56&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5be6ce56"]])

export default __exports__